import React from 'react'
import { Redirect, Route } from 'react-router'
import PropTypes from 'prop-types';
const PrivateRoutes = ({ isAuthenticate, component: Component, ...rest }) => {
    return (
        <Route 
            {...rest}
            component={
                // Props contain history, search and location from react router
                (props)=> (
                    (isAuthenticate)
                    ? <Component {...props}/>
                    : (<Redirect to="/auth/login"/>)
                )
            }
        />
    )
};

PrivateRoutes.propTypes = {
    isAuthenticate: PropTypes.bool.isRequired,
    component: PropTypes.func.isRequired
}

export default PrivateRoutes
